import { FC, useEffect, useState } from "react";
import "../../../App.css";
import toGroupLayers, { weatherLayerGroup } from "../weatherLayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudRain } from "@fortawesome/free-solid-svg-icons";
import { LocationMarkerPopup } from "../../MainWindow";
import Tooltip from "@mui/material/Tooltip";
import { getGlobalLayer } from "../../MainWindow";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { allWeatherMapECMWF, allWeatherMapICON } from "../weatherLayer";
import { weatherMapECMF, weatherMapICON } from "../weatherLayer";
import { ecmf, ICON } from "../weatherLayer";
import { ThemeProvider, useTheme } from "../../../theme/ThemeContext";
import { useMenu } from "../../../roundMenuContext/roundMenuContext";
import {
  ecmf3hEnd,
  ecmf3hInterval,
  ecmf3hStart,
  ecmf6hEnd,
  ecmf6hInterval,
  ecmf6hStart,
  icon1hInterval,
  icon1hStart,
  icon1hEnd,
  icon3hInterval,
  icon3hStart,
  icon3hEnd,
  layerStartDate,
  layerIconStartDate,
} from "../../../TimeLine/BackgroundMapTimeLine/TimeLineService";
import { useMapLayersContext } from "../../../provider/MapLayers";

interface RainLayerrProps {
  setTimeLayer: (layer: string) => void;
  weatherlayerState: string;
  senddValueFromRain: (value: string) => void;
  timeLineHour: string;
  timeLineDate: string;
  selectModel: string;
}

let isButtonClicked: boolean = false;
let rainMap: Map<string, ImageLayer<ImageWMS>> = new Map();
let rainMapICON: Map<string, ImageLayer<ImageWMS>> = new Map();

const AccumulatedRainLayer: React.FC<RainLayerrProps> = ({
  setTimeLayer,
  weatherlayerState,
  senddValueFromRain,
  timeLineHour,
  timeLineDate,
  selectModel,
}) => {
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [timeLineCounter, setTimeLineCounter] = useState<number>(0);
  const [hoveredRainAcc, setHoveredRainAcc] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();
  const { selectLayerInMap, loadLayerInMap,setIsRainLoad,isRainLoad } = useMapLayersContext();
  const [isButtonChanged, setIsButtonChanged] = useState<boolean>(false);
  const [isECMWFLoad, setIsECMWFLoad] = useState<boolean>(false);

  useEffect(() => {
    if (weatherlayerState === "rainnot") {
      if (selectModel === "ICON") {
        try {
          const layer = rainMapICON.get(timeLineDate + "-" + timeLineHour);
     
          if (layer) {
            getGlobalLayer(layer);
            toGroupLayers(layer, false, "rain");
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      } else {
        try {
          const layer = rainMap.get(timeLineDate + "-" + timeLineHour);
      
          if (layer) {
            getGlobalLayer(layer);
            toGroupLayers(layer, false, "rain");
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      }
    }
  }, [timeLineHour, timeLineDate]);

  useEffect(() => {
    if (menu === "Accumulated Rain") {
      isButtonClicked = false;
      setIsClicked((prevState) => !prevState);

      if (isClicked == true) {
        setTimeLayer("rain");
        LocationMarkerPopup("rain");
      } else if (isClicked === false) {
        senddValueFromRain("rain");
        setTimeLayer("rainnot");
        LocationMarkerPopup("rainnot");
      }
      rainIconClick();
    }
  }, [menu]);

  useEffect(() => {
    if(!isRainLoad){
      if(loadLayerInMap==="rain"){
        if (isClicked == true) {
          setTimeLayer("rain");
          LocationMarkerPopup("rain");
          rainIconClick();
          selectLayerInMap("rainnot");
          setIsClicked(false);
        } else if (isClicked === false) {
          senddValueFromRain("rain");
          setTimeLayer("rainnot");
          LocationMarkerPopup("rainnot");
          selectLayerInMap("rain");
          setIsClicked(true);
        }
      }else if(loadLayerInMap==="rainnot"){
        setTimeLayer("rain");
        LocationMarkerPopup("rain");
        rainIconClick();
        selectLayerInMap("rainnot");
        setIsClicked(false);
      }
      setIsRainLoad(true);
    }
}, [loadLayerInMap]);


  function formatTimestamp(timestamp: number): string {
    const date = new Date(timestamp * 1000); // Multiply by 1000 to convert to milliseconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}-${hour}:${minute}`;
  }

  function parseDateString(dateString: string): string | null {
    const offsetMinutes = new Date().getTimezoneOffset();

    const dateRegex = /^(\d{4})-(\d{2})-(\d{2})-(\d{2}):(\d{2})$/;
    const match = dateString.match(dateRegex);
    if (!match) {
      console.error("Invalid date format:", dateString);
      return null;
    }
    const [, year, month, day, hour, minute] = match;
    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute)
    );
    date.setMinutes(date.getMinutes() + offsetMinutes);
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    return formattedDate;
  }

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (isButtonChanged) {
      // selectLayerInMap("rain");
    }
  }, [isButtonChanged]);

  useEffect(() => {
    if (ecmf6hStart && ecmf6hStart !== 0) {
      setIsReady(true); // Set ready state to true when ecmf6hStart is valid
    }
  }, [ecmf6hStart]);

  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-CA");

  const resultMap = new Map<number, string>();

  const cachedMap: Map<string, Map<string, boolean>> = new Map();

  async function preloadImage(
    url: string,
    bbox: string,
    layer: string
  ): Promise<void> {
    try {
      const cache = await caches.open("image-cache");
      const cachedResponse = await cache.match(url);

      let cachedByLayer: Map<string, boolean> = new Map();

      if (cachedMap.get(bbox) != null) {
        cachedByLayer = cachedMap.get(bbox)!;
      } else {
        cachedMap.set(bbox, cachedByLayer);
      }
      if (
        cachedByLayer.get(layer) != null &&
        cachedByLayer.get(layer) == true
      ) {
      } else {
        const response = await fetch(url);
        if (response.ok) {
          const blob = await response.blob();
          await cache.put(url, new Response(blob));
          const imgElement = document.createElement("img");
          imgElement.src = url;
          cachedByLayer.set(layer, true);
          cachedMap.set(bbox, cachedByLayer);
        } else {
          cachedByLayer.set(layer, false);
          cachedMap.set(bbox, cachedByLayer);
          console.error("Failed to fetch image:", response.statusText);
        }
      }
      setIsButtonChanged(true);
    } catch (error) {
      console.error("Error during image caching and preload:", error);
    }
  }

  useEffect(() => {
    if (!isReady) return;
    if (weatherlayerState === "rainnot" && selectModel === "ECMWF") {
      setIsClicked(true);
      let i = 0;
      for (; i <= 48; i++) {
        const value = ecmf3hStart + i * ecmf3hInterval;
        if (value > ecmf3hEnd) break;
        resultMap.set(i, formatTimestamp(value));
      }

      for (let j = i; j <= 64; j++) {
        const value = ecmf6hStart + (j - 48) * ecmf6hInterval;
        if (value > ecmf6hEnd) break;
        resultMap.set(j, formatTimestamp(value));
      }

      try {
        for (let i = 0; i <= ecmf.size; i++) {
          let dateBefore = resultMap.get(i) ?? "";
          let dayPass = parseDateString(dateBefore);

          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerStartDate}_ecmwf_${dayPass}:00_tp`,
                STYLES: "weather:rain",
              },
              imageLoadFunction: (image, src) => {
                const [baseUrl, queryString] = src.split("?");
                const queryParams = new URLSearchParams(queryString);

                const urlObj = new URL(src);
                const layers = urlObj.searchParams.get("LAYERS");
                const bbox = urlObj.searchParams.get("BBOX");

                for (let cnti = i; cnti < Math.min(i + 10, ecmf.size); cnti++) {
                  let dateBeforeCache = resultMap.get(cnti) ?? "";
                  let dayPassCache = parseDateString(dateBeforeCache);

                  queryParams.set(
                    "LAYERS",
                    `weather:${layerStartDate}_ecmwf_${dayPassCache}:00_tp`
                  );
                  const urlCached = `${baseUrl}?${queryParams.toString()}`;

                  preloadImage(
                    urlCached,
                    bbox!,
                    `weather:${layerStartDate}_ecmwf_${dayPassCache}:00_tp`
                  );
                }

                const modifiedSrc = `${src}`;
                const imgElement = image.getImage();
                if (imgElement instanceof HTMLImageElement) {
                  imgElement.src = modifiedSrc;
                } else {
                  console.error(
                    "imageLoadFunction: Expected an HTMLImageElement but got:",
                    imgElement
                  );
                }
              },
              serverType: "geoserver",
              projection: "EPSG:4326",
            }),
          });
          layers.set("name", `rain_${i}`);
          const key = resultMap.get(i);
          if (key !== undefined) {
            rainMap.set(key, layers);
          }
          allWeatherMapECMWF("rainEcmwf", rainMap);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }

      // ------------------------------------------------------------------
      try {
        if (rainMap) {
          const layer = rainMap.get(timeLineDate + "-" + timeLineHour);
          if (layer) {
            getGlobalLayer(layer);
            if (!isButtonClicked) {
              toGroupLayers(layer, !isClicked, "rain");
            } else {
              toGroupLayers(layer, false, "rain");
            }
          }
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }

      // ----------------------------------------------------------------
    } else if (weatherlayerState === "flood") {
      setIsClicked(false);
      LocationMarkerPopup("rain");
    } else if (weatherlayerState === "satellite not") {
      setIsClicked(false);
      LocationMarkerPopup("rain");
    } else if (weatherlayerState === "rainnot") {
      setIsClicked(true);
    } else {
      setIsClicked(false);
    }
  }, [weatherlayerState, isClicked, isReady, selectModel]);

  useEffect(() => {}, [isButtonClicked]);

  useEffect(() => {}, [isClicked]);

  const [isIconReady, setIconReady] = useState(false);

  useEffect(() => {
    if (icon3hStart && icon3hStart !== 0) {
      setIconReady(true);
    }
  }, [icon3hStart]);

  const resultIconMap = new Map<number, string>();

  useEffect(() => {
    if (!isIconReady) return;
    if (selectModel === "ICON" && weatherlayerState === "rainnot") {
      let i = 0;
      for (; i <= 78; i++) {
        const value = icon1hStart + i * icon1hInterval;
        if (value > icon1hEnd) break;
        resultIconMap.set(i, formatTimestamp(value));
      }

      for (let j = i; j <= 112; j++) {
        const value = icon3hStart + (j - 78) * icon3hInterval;
        if (value > icon3hEnd) break;
        resultIconMap.set(j, formatTimestamp(value));
      }

      try {
        for (let i = 0; i <= ICON.size; i++) {
          let dateBefore = resultIconMap.get(i) ?? "";
          let dayPass = parseDateString(dateBefore);

          var layers = new ImageLayer({
            source: new ImageWMS({
              url: "https://wms.tecxal.com/visura/weatherwmseagle",
              params: {
                LAYERS: `weather:${layerIconStartDate}_icon_${dayPass}:00_tp`,
                STYLES: "weather:iconrain",
              },
              imageLoadFunction: (image, src) => {
                const [baseUrl, queryString] = src.split("?");
                const queryParams = new URLSearchParams(queryString);

                const urlObj = new URL(src);
                const layers = urlObj.searchParams.get("LAYERS");
                const bbox = urlObj.searchParams.get("BBOX");

                for (let cnti = i; cnti < Math.min(i + 10, ICON.size); cnti++) {
                  let dateBeforeCache = resultIconMap.get(cnti) ?? "";
                  let dayPassCache = parseDateString(dateBeforeCache);

                  queryParams.set(
                    "LAYERS",
                    `weather:${layerIconStartDate}_icon_${dayPassCache}:00_tp`
                  );
                  const urlCached = `${baseUrl}?${queryParams.toString()}`;

                  preloadImage(
                    urlCached,
                    bbox!,
                    `weather:${layerIconStartDate}_icon_${dayPassCache}:00_tp`
                  );
                }

                const modifiedSrc = `${src}`;
                const imgElement = image.getImage();
                if (imgElement instanceof HTMLImageElement) {
                  imgElement.src = modifiedSrc;
                } else {
                  console.error(
                    "imageLoadFunction: Expected an HTMLImageElement but got:",
                    imgElement
                  );
                }
              },
              serverType: "geoserver",
              projection: "EPSG:4326",
            }),
          });

          layers.set("name", `rain_${i}`);
          const key = resultIconMap.get(i);
          if (key !== undefined) {
            rainMapICON.set(key, layers);
          }
          allWeatherMapICON("rainIcon", rainMapICON);
        }
        weatherLayerGroup.getLayers().clear();
        try {
          if (rainMapICON) {
            const layer = rainMapICON.get(timeLineDate + "-" + timeLineHour);
            if (layer) {
              getGlobalLayer(layer);
              if (!isButtonClicked) {
                toGroupLayers(layer, !isClicked, "rain");
              } else {
                toGroupLayers(layer, false, "rain");
              }
            }
          }
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    }
  }, [selectModel, isIconReady, weatherlayerState]);

  useEffect(() => {}, [isECMWFLoad]);

  const rainIconClick = async () => {
    try {
      let rainLayerMap;
      if (selectModel === "ECMWF") {
        rainLayerMap = weatherMapECMF.get("rainEcmwf");
      } else if (selectModel === "ICON") {
        rainLayerMap = weatherMapICON.get("rainIcon");
      }

      if (rainLayerMap) {
        const layer = rainLayerMap.get(timeLineDate + "-" + timeLineHour);

        if (layer) {
          getGlobalLayer(layer);
          toGroupLayers(layer, true, "rain");
        }
      }
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };

  return (
    <>
      <div
        className="leftsidemenulist-btn-cover"
        onClick={() => {
          isButtonClicked = false;
          setIsClicked((prevState) => !prevState);

          if (isClicked == true) {
            setTimeLayer("rain");
            LocationMarkerPopup("rain");
            rainIconClick();
            selectLayerInMap("rainnot");
          } else if (isClicked === false) {
            senddValueFromRain("rain");
            setTimeLayer("rainnot");
            LocationMarkerPopup("rainnot");
            selectLayerInMap("rain");
          }
        }}
        onTouchStart={() => {
          isButtonClicked = false;
          setIsClicked((prevState) => !prevState);

          if (isClicked == true) {
            setTimeLayer("rain");
            LocationMarkerPopup("rain");
            rainIconClick();
            selectLayerInMap("rainnot");
          } else if (isClicked === false) {
            senddValueFromRain("rain");
            setTimeLayer("rainnot");
            LocationMarkerPopup("rainnot");
            selectLayerInMap("rain");
          }
        }}
      >
        <div
          onMouseEnter={() => setHoveredRainAcc(true)}
          onMouseLeave={() => setHoveredRainAcc(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon
            size="1x"
            icon={faCloudRain}
            className="leftside-icon"
          />
        </div>
        {theme === "light" && (
          <div
            className={
              isClicked
                ? "leftsidemenulist-btn-tooltip-clicked-light"
                : hoveredRainAcc
                ? "leftsidemenulist-btn-tooltip-hover-light"
                : "leftsidemenulist-btn-tooltip-light"
            }
            onMouseEnter={() => setHoveredRainAcc(true)}
            onMouseLeave={() => setHoveredRainAcc(false)}
          >
            Accumulated Rain
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isClicked
                ? "leftsidemenulist-btn-tooltip-clicked"
                : hoveredRainAcc
                ? "leftsidemenulist-btn-tooltip-hover"
                : "leftsidemenulist-btn-tooltip"
            }
            onMouseEnter={() => setHoveredRainAcc(true)}
            onMouseLeave={() => setHoveredRainAcc(false)}
          >
            Accumulated Rain
          </div>
        )}
      </div>
    </>
  );
};

export default AccumulatedRainLayer;
